
import ProductsCard from "./ProductsCard";
const Products=({products})=>{
    console.log(products)
    return(<div className="py-10  overflow-x-hidden">
     <div className="flex flex-col items-center gap-4">
        <h1 className="text-2xl bg-black text-white py-2 w-80 text-center">Shopping Everyday</h1>
        <span className="w-20 h-[3px] bg-black"></span>
        <p className="max-w-[700px] text-gray-600 text-center py-10"> 
        Discover a world of convenience and excitement with our "Shopping Everyday" feature. Enjoy daily deals, exclusive offers, and a wide range of products to fit your lifestyle needs. Whether you're looking for the latest fashion, home essentials, or the best tech gadgets, we've got you covered. Shop smarter, save more, and make every day a shopping day with us!
        </p>
     </div>

     <div className="max-w-screen-xl mx-auto py-10 grid grid-cols-4 gap-10">
    {products.map((product)=>(<ProductsCard  key={product._id} product={product} ></ProductsCard> ))}
     </div>
     
    </div>)
}
export default Products;